﻿import type {ImportProject} from "../types/imports/import-project.type";
import type {ImportProjectMap} from "../types/imports/import-project-map.type";
import type {ImportMeasurements} from "../types/imports/import-measurements.type";
import type {ImportMeasurementsRequest} from "../types/requests/import-measurements-request.type";
import {makeApiCall} from "./client";
import type {ImportMeasurementsRequestOptions} from "../types/imports/import-measurements-rquest-options.type";

const oldLisaApi = '/old-lisa-api';

export async function getOldLisaProjectList(token: string): Promise<ImportProject[]>{
    const response = await makeOldLisaApiCall('projects/get', token);
    return response.Items as ImportProject[];
}

export async function getOldLisaProjectMap(token: string, id: string): Promise<ImportProjectMap>{
    return await makeOldLisaApiCall('project/insight/get', token, {Id: id});
}

export async function getOldLisaProjectMeasurements(token: string, options: ImportMeasurementsRequestOptions): Promise<ImportMeasurements>{
    return await makeOldLisaApiCall('project/insight/measurements/get', token, options);   
}

export async function getOldLisaProjectMeasurementTimestamp(token: string, id: string): Promise<number>{
    // We've agreed with Buko to only import measurements after 2025-07-01
    const body = {
        ProjectId: id,
        MinTimestamp: "2025-07-01T00:00:00.000Z"
    };

    const value = await makeOldLisaApiCall('project/insight/measurementTimestamps/get', token, body);
    const timestampArray: string[] = value.Timestamps;

    return timestampArray.length
}

export async function postImportedMeasurements(id: string, body: ImportMeasurementsRequest) {
    return await makeApiCall(`api/projects/${id}/import-measurements`, 'POST', body);  
}

async function makeOldLisaApiCall(endpoint: string, token: string, content?: unknown) {
    console.log(`Making call to ${oldLisaApi}/${endpoint}`);
    const response = await fetch(
        `${oldLisaApi}/${endpoint}`, 
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${token}`
            },
            body: content ? JSON.stringify(content) : undefined
        }
    );

    if (!response)
        return;

    if (response.status !== 200)
        throw new Error(`Error ${response.status} occurred while making an API call to ${name}: ${response.statusText} `);

    if (!response.ok)
        throw new Error(`HTTP ${response.status}`);

    const responseAsText = await response.text();
    const responseAsJson = responseAsText ? JSON.parse(responseAsText) : null;

    return responseAsJson?.value ? responseAsJson?.value : responseAsJson;
}